import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {getActiveTests} from 'services/target';

import {AuthActions} from 'store/auth/auth.reducer';

export interface TargetState {
  readonly activeTests: string[];
  readonly adobeScriptLoaded: boolean;
}

export const initialState: TargetState = {
  activeTests: getActiveTests(),
  adobeScriptLoaded: false,
};

const {actions: TargetActions, reducer: TargetReducer} = createSlice({
  name: 'target',
  initialState,
  reducers: {
    setTargetTests(state, action: PayloadAction<TargetState>) {
      state.adobeScriptLoaded = action.payload.adobeScriptLoaded;
      state.activeTests = [
        ...state.activeTests,
        ...action.payload.activeTests.map((test: string) => test.toLowerCase()),
      ];
    },
  },
  extraReducers: builder => {
    builder.addCase(AuthActions.logout.type, () => initialState);
  },
});

export {TargetActions, TargetReducer};
export default TargetReducer;
